<script>
import { _ } from 'svelte-i18n';
import { onMount } from 'svelte';
import { info_client, client } from '../stores';
  import { getBaseApiUrl } from '../../api/base';

const name_url = getBaseApiUrl();
let isShowShop = false;

$: isShowShop = $info_client.flow?.shop_icon_status === 'available' || $client.flow?.settings.shop_icon_status === 'available'

// onMount(()=> {
//   name_url = PHT_URL;
// });

</script>

{#if !$info_client.is_staff}

  <div class="lower__header">
    <a href={name_url} class="lower__header_item text-bold">
      <svg width="20" height="20" viewBox="0 0 20 20"><path xmlns="http://www.w3.org/2000/svg" d="M2.5 7.55425C2.5 7.20946 2.67762 6.88899 2.97 6.70625L9.97 2.33125C10.2943 2.12858 10.7057 2.12858 11.03 2.33125L18.03 6.70625C18.3224 6.88899 18.5 7.20946 18.5 7.55425V17C18.5 17.5523 18.0523 18 17.5 18H12.8333C12.6492 18 12.5 17.8508 12.5 17.6667V13C12.5 11.8954 11.6046 11 10.5 11C9.39543 11 8.5 11.8954 8.5 13V17.6667C8.5 17.8508 8.35076 18 8.16667 18H3.5C2.94772 18 2.5 17.5523 2.5 17L2.5 7.55425Z"></path></svg>
      <span>{$_('headerHome')}</span>
    </a>
    <a href={name_url+"client/progress/"} class="lower__header_item text-bold">
      <svg width="20" height="20" viewBox="0 0 20 20"><path d="M2.75 4C2.75 2.89543 3.64543 2 4.75 2C5.85457 2 6.75 2.89543 6.75 4V14H2.75V4Z"></path><path d="M8.75 7C8.75 5.89543 9.64543 5 10.75 5C11.8546 5 12.75 5.89543 12.75 7V14H8.75V7Z"></path><path d="M14.75 11C14.75 9.89543 15.6454 9 16.75 9C17.8546 9 18.75 9.89543 18.75 11V14H14.75V11Z"></path><rect x="1.75" y="16" width="18" height="2" rx="1"></rect></svg>
      <span>{$_('headerProgressShort')}</span>
    </a>
    <a href={name_url+'client/board/'} class="lower__header_item text-bold">
      <svg width="22" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3C3.34315 3 2 4.34315 2 6V12C2 13.6569 3.34315 15 5 15H18V6C18 4.34315 16.6569 3 15 3H5ZM6 10C6.55228 10 7 9.55228 7 9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10ZM11 9C11 9.55228 10.5523 10 10 10C9.44772 10 9 9.55228 9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9ZM14 10C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9C13 9.55228 13.4477 10 14 10Z"></path><path d="M18 15H13L18 18L18 15Z"></path></svg>
      <span>{$_('headerTheme')}</span>
    </a>
    <a href=" " class="lower__header_item lower__header_item--active text-bold">
      <svg width="20" height="20" viewBox="0 0 20 20"><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M3 2.75C2.86193 2.75 2.75 2.86193 2.75 3V17C2.75 17.1381 2.86193 17.25 3 17.25H17C17.1381 17.25 17.25 17.1381 17.25 17V3C17.25 2.86193 17.1381 2.75 17 2.75H3ZM9.32257 5.76545L6.15669 4.09848H9.32253L9.32257 5.76545ZM10.6775 5.76546L10.6775 4.09848H13.8434L10.6775 5.76546ZM4.10496 14.3717V4.54376L9.01657 7.12992L4.10496 14.3717ZM15.895 14.3717L10.9836 7.12992L15.895 4.54377V14.3717ZM15.2979 15.9015H4.70215L10.0001 8.09014L15.2979 15.9015Z"></path></svg>
      <span>{$_('headerContent')}</span>
    </a>
    {#if isShowShop}
      <a href={name_url+'jwt-auth/redirect-refresh-token/to-shop/'} class="lower__header_item text-bold">
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path
            d="M14.6424 6.0144C15.7506 6.0144 16.9129 6.81199 17.3236 8.75012L17.9978 14.1817C18.4938 17.7229 16.5022 19.1666 13.8288 19.1666H6.56004C3.87883 19.1666 1.8253 18.1696 2.38324 14.1817L3.06517 8.75012C3.41388 6.75616 4.615 6.0144 5.73863 6.0144H14.6424ZM6.84008 8.93356C6.4121 8.93356 6.06516 9.29066 6.06516 9.73115C6.06516 10.1716 6.4121 10.5287 6.84008 10.5287C7.26805 10.5287 7.61499 10.1716 7.61499 9.73115L7.60895 9.6311C7.56114 9.23783 7.23513 8.93356 6.84008 8.93356ZM13.51 8.93356C13.082 8.93356 12.7351 9.29066 12.7351 9.73115C12.7351 10.1716 13.082 10.5287 13.51 10.5287C13.938 10.5287 14.2849 10.1716 14.2849 9.73115C14.2849 9.29066 13.938 8.93356 13.51 8.93356Z"></path>
          <path
            d="M10.1826 3.22456C8.86192 3.22456 7.7913 4.29518 7.7913 5.61586C7.7913 5.75118 7.80254 5.88387 7.82413 6.01305L7.82436 6.01441H5.73875C5.63229 6.01441 5.52514 6.02107 5.41809 6.03482C5.40611 5.89676 5.39999 5.75703 5.39999 5.61586C5.39999 2.9745 7.54124 0.833252 10.1826 0.833252C12.824 0.833252 14.9652 2.9745 14.9652 5.61586C14.9652 5.75697 14.9591 5.89666 14.9471 6.03466C14.8456 6.02108 14.7438 6.01441 14.6425 6.01441H12.5408C12.5626 5.8848 12.5739 5.75165 12.5739 5.61586C12.5739 4.29518 11.5033 3.22456 10.1826 3.22456Z"></path>
        </svg>
        <span>{$_('headerStore')}</span>
      </a>
    {/if}
  </div>

{/if}

<style lang="scss">

.lower__header {
  width: 100%;
   position: fixed;
  left: 0; bottom: 0;
  max-height: 54px;
  display: none;
   -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-pack: distribute;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 9999;
  padding: 8px 0;
  background-color: #FFFFFF;
  border-radius: 16px 16px 0 0;
  -webkit-box-shadow: 0px 2px 8px rgba(16, 16, 122, 0.16);
  box-shadow: 0px 2px 8px rgba(16, 16, 122, 0.16);
}

.lower__header_item{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 2px;
  text-decoration: none;

  > span {
    font-size: 12px;
    line-height: 16px;
    color: #BDBFC4;
    white-space: nowrap;
  }

  > svg {
    fill: #BDBFC4;
  }

  &:hover {
    > span {
      color: #2B50ED;
    }
    > svg {
      fill: #2B50ED;
    }
  }

  &--active {
    > span {
      color: #2B50ED;
    }

    > svg {
      fill: #2B50ED;
    }
  }
}
.lower__header_item:first-child{
  padding-left: 16px;
}
.lower__header_item:last-child{
  padding-right: 16px;
}

 @media (max-width: 768px){
  .lower__header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
</style>
